/**
 * Single skeleton-block primitive.
 *
 * Usage:
 *   <Skeleton height={24} width="60%" />
 *   <Skeleton variant="circle" size={80} />
 */
import { clsx } from "clsx";

type SkeletonProps = {
  width?: number | string;
  height?: number | string;
  size?: number | string; // shorthand for square
  variant?: "bar" | "circle";
  className?: string;
};

export function Skeleton({
  width,
  height,
  size,
  variant = "bar",
  className,
}: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (size != null) {
    style.width = typeof size === "number" ? `${size}px` : size;
    style.height = typeof size === "number" ? `${size}px` : size;
  } else {
    if (width != null) style.width = typeof width === "number" ? `${width}px` : width;
    if (height != null) style.height = typeof height === "number" ? `${height}px` : height;
  }
  if (variant === "circle") style.borderRadius = "50%";
  return (
    <span
      className={clsx("skeleton inline-block", className)}
      style={style}
      aria-hidden
    />
  );
}
